<template>
  <v-card>
    <v-container fluid grid-list-lg>
      <v-form v-model="validate.pin">
        <v-flex xs12>
          <v-select
            :items="companies"
            v-model="pin.companyId"
            label="Company"
            item-text="tradingName"
            item-value="id"
            required
            :rules="rules"
            :disabled="disabled"
            autocomplete
          />
        </v-flex>

        <v-layout row wrap>
          <v-flex xs12 md3>
            <!-- <v-text-field
              id="protocol"
              type="text"
              label="Protocol"
              v-model="pin.protocol"
              :disabled="disabled"
              required
              :rules="rules"
              append-icon="info"
              :append-icon-cb="showTooltip('protocol')"
            /> -->
            <v-select
              :items="protocols"
              v-model="pin.protocol"
              label="Protocol"
              required
              :rules="rules"
              :disabled="disabled"
              autocomplete
            />
          </v-flex>

          <v-flex xs12 md6>
            <v-text-field
              id="host"
              type="text"
              label="Host"
              v-model="pin.host"
              :disabled="disabled"
              required
              :rules="rules"
              append-icon="info"
              :append-icon-cb="showTooltip('host')"
            />
            <v-tooltip
              v-model="tooltip.host"
              activator="#host + .icon"
              lazy
              left
            >
              <span>IP address or hostname</span>
            </v-tooltip>
          </v-flex>

          <v-flex xs12 md3>
            <v-text-field
              id="v-patch"
              type="number"
              label="Port"
              min="1"
              max="65535"
              v-model="pin.port"
              :disabled="disabled"
              required
              :rules="rules"
              append-icon="info"
              :append-icon-cb="showTooltip('port')"
            />
            <v-tooltip
              v-model="tooltip.port"
              activator="#v-patch + .icon"
              lazy
              left
            >
              <span>Domain port number</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <span class="caption">{{ completeUrl }}</span>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'pin-form',
  props: {
    pin: Object,
    companies: Array,
    disabled: Boolean,
    validate: Object,
  },
  data: () => ({
    file: null,
    rules: [v => !!v || 'Is required'],
    tooltip: {
      host: false,
      port: false,
    },
    protocols: ['http', 'https'],
  }),
  computed: {
    maxDate() {
      return new Date().toISOString();
    },
    completeUrl() {
      const { protocol, host, port } = this.pin;
      return protocol && host && port ? `${protocol}://${host}:${port}` : '';
    },
  },
  methods: {
    showTooltip(tooltip) {
      return () => {
        this.$set(this.tooltip, tooltip, true);
        setTimeout(() => { this.$set(this.tooltip, tooltip, false); }, 3000);
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pin/pin-form.vue